import { useEffect, useState } from "react";
import { Singleton } from "../../../../../core/services/Singleton";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { toast } from "react-toastify";
import { ListMenu } from "../../../../theme/Component/ListMenu";
import { BasicTable } from "../../../../theme/Component/BasicTable";
import { Modal } from "../../../../theme/Component/Modal";
import { ModalConfirm } from "../../../../theme/Component/ModalConfirm";
import { SelectRol } from "../../../../admin/select/SelectRol";
import usePaginator from "../../../../theme/Component/usePaginator";
import { BasicButton } from "../../../../theme/Component/BasicButton";
import { _AgencyRole, _AgencyUser } from "../../../../../core/services/dataBean/EntityCatalogVdos";
import { AccountEditor } from "../../../../editor/AccountEditor";


interface Props {
    idAgencyRole: number;
}

export const AgencyUser = ({ idAgencyRole }: Props) => {

    const roleuser = useDataBean(_AgencyUser);
    const paginador = usePaginator();
    const single = Singleton.getInstance();
    const [Acc, setAcc] = useState<number>(null)
    const [lista, setLista] = useState<any>([]);
    const [modal, setModal] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalinrole, setModalinrole] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalC, setModalC] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [paginador.page, idAgencyRole])

    const getLista = () => {

        roleuser.instance.getAgencyUserCatalog(idAgencyRole, Acc, paginador.page, 15).then(
            (resp: any) => {
                if (resp) {
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * (15));
                    paginador.setRegiPerPage(15)
                    setLista(resp.List)
                }
            }
        )

    }

    const create = () => {
        roleuser.setBean({

        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        roleuser.instance.deleteAgencyUser(roleuser.bean.IDAgencyUser).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )

    }
    const editaItem = () => {
        ////console.log(SubMacroProcess.bean);
        roleuser.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    const addAgencyUser = () => {

        roleuser.instance.addAgencyUser(idAgencyRole, roleuser.bean.IDAccount, single.getAccountID()).then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    const head = [
        { title: 'ID', property: 'IDAgencyUser', visible: true },
        { title: 'Usuario', property: 'AccountName', visible: true },

    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [

            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "view": true }) } },
            { titulo: 'Usuarios en Role', icono: 'ri-shield-user-line', visible: single.canEdit(), evento: () => { setModalinrole({ ...modalinrole, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <div className="row">
            <div className="col-md-12">
                <label>Usuarios en Role</label>
            </div>
            <div className="col-md-4">
                <AccountEditor label='Usuario' idAccount={Acc} onChange={(e: any) => { setAcc(e) }}></AccountEditor>
            </div>
            <div className="col-md-6 mt-4 p-2">
                <BasicButton icon="ri-align-justify" eventClick={getLista}>Buscar</BasicButton>
            </div>
            <div className="col-md-12">
                <BasicTable body={lista} head={head} rowSet={roleuser.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem} pageTop={paginador.page} next={paginador.next} back={paginador.back} records={paginador} customRows={15}></BasicTable>
                <Modal modal={modal} updateModal={setModal} eventModal={addAgencyUser}>
                    <div className="row">
                        <div className="col-md-12">
                            <AccountEditor idAccount={roleuser.bean.IDAccount} onChange={(e) => { roleuser.setBean({ ...roleuser.bean, IDAccount: e.IDAccount }) }} label="Usuario" />
                        </div>
                    </div>
                </Modal>
                <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                    <strong>Eliminar item</strong>
                </ModalConfirm>
            </div>

        </div>
    )
}